<template>
  <div id="app">
    <electron-menu></electron-menu>
    <router-view></router-view>
  </div>
</template>

<script>
import ElectronMenu from './components/common/ElectronMenu.vue';
import useConfigStore from './store/configStore';


export default {
  name: 'App',
  components: {ElectronMenu},
  mounted() {
    if (window.electronAPI) {
      const configStore = useConfigStore();
      // 标记是否客户端模式
      configStore.setElectronMode(true)
      // 版本校验应该在应用初始化时进行
      this.checkAppVersion();
      // 监听客户端的全屏/退出事件
      window.electronAPI.invoke('isFullScreen').then(fullScreen => {
        configStore.setFullScreen(fullScreen);
      })
    }
  },
  methods: {
    async checkAppVersion() {
      try {
        const version = require("/package.json").version;
        const res = await this.$http({
          url: '/system/checkVersion?version=' + version
        });
        if (!res.isLatestVersion) {
          await this.$confirm(
              `发现新版本，请自行选择是否前往浏览器下载安装`,
              '版本更新提醒',
              {
                confirmButtonText: '前往下载',
                cancelButtonText: '稍后更新',
                type: 'warning'
              }
          );
          // 在 Electron 环境中打开默认浏览器下载
          // window.electronAPI.invoke('openExternal', 'https://qiniu.sgwlkj.ren/upgrade/upgrade-y-least.exe');
          window.electronAPI.invoke('openExternal', 'http://101.43.190.3/');
        }
      } catch (error) {
        console.error("获取版本信息异常:", error);
      }
    },
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
